import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React from "react";

const CommingSoonPage = () => {
  return (
    <>
    <Header />
    <section className="coming-soon">
      <div className="coming-soon-inner">
      {/* <h1 className="fw-bold text-white">Terpnash</h1>

        <h1 className="fw-bold text-white">Coming soon</h1> */}
      </div>
    </section>
     <Footer />
     </>
  );
};

export default CommingSoonPage;
